import { ChangeEvent } from 'react';
import { FormField } from './FormField';
 
type DateFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  minDate?: string;
  maxDate?: string;
};
 
export const DateField = ({
  label,
  value,
  onChange,
  error,
  minDate,
  maxDate
}: DateFieldProps) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
	onChange(e.target.value);
  };
 
  return (
	<FormField label={label} error={error}>
	  <input
		type="date"
		className="form-input-small"
		value={value}
		onChange={handleChange}
		min={minDate}
		max={maxDate}
	  />
	</FormField>
  );
};